<template>
  <v-dialog v-model="dialog" persistent width="750">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9> <v-icon>done</v-icon>Aprobar solicitudes </v-flex> 
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout>
              <v-flex xs9>
                <h4>
                  <strong
                    >Listado de servidores publicos que no enviarón su
                    programación ó estan observados</strong
                  >
                </h4>
              </v-flex>
              <v-flex xs3>
                <v-menu open-on-hover buttom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">help_outline</v-icon>
                  </template>
                  <v-card>
                    <v-card-text class="ayuda">
                      <v-layout>
                        <v-flex class="text-xs-center caption">
                          <strong>
                            <p><v-icon>help_outline</v-icon></p>
                            <p>Solo puede aprobar las programaciones cuando</p>
                            <p>
                              todos los servidores públicos del listado hayan
                              enviado
                            </p>
                            <p>
                              sus programaciones y no se encuentren rechazados
                              por el
                            </p>
                            <p>
                              jefe inmediato superior correspondiente al
                              servidor público
                            </p>
                          </strong>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-menu>
              </v-flex>
            </v-layout>
            <v-layout v-if="listado_funcionarios.length == 0">
              <v-card color="#DFFF89">
                <h4>
                  <strong
                    >Todos los servidores enviaron su programación de vacaciones
                    y se encuentran sin observaciones</strong
                  >
                </h4>
              </v-card>
            </v-layout>
            <v-layout v-if="listado_funcionarios.length > 0">
              <v-flex xs12>
                <v-data-table
                  :items="listado_funcionarios"
                  class="elevation-1"
                  hide-actions
                  :headers="headers"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">{{ props.item.nombre }}</td>
                    <td class="text-xs-center">{{ props.item.unidad }}</td>
                    <td class="text-xs-center">
                      <v-chip
                        dark
                        :color="
                          props.item.id_estado == 22
                            ? '#9637FF'
                            : props.item.id_estado == 51
                            ? '#00DB15'
                            : props.item.id_estado == 73
                            ? '#7ee06a'
                            : props.item.id_estado == 66
                            ? '#73b6c4'
                            : props.item.id_estado == 72
                            ? '#9d20b6'
                            : props.item.id_estado == 70
                            ? '#c267a5'
                            : props.item.id_estado == 47
                            ? '#9aed65'
                            : props.item.id_estado == 68
                            ? '#6f9eb8'
                            : props.item.id_estado == 67
                            ? '#83e0e3'
                            : props.item.id_estado == 66
                            ? '#b0bed6'
                            : props.item.id_estado == 65
                            ? '#c267be'
                            : props.item.id_estado == 54
                            ? '#8f66b8'
                            : props.item.id_estado == 58
                            ? '#88a7f5'
                            : props.item.id_estado == 57
                            ? '#7c73c3'
                            : props.item.id_estado == 56
                            ? '#64a054'
                            : props.item.id_estado == 55
                            ? '#19afb4'
                            : '#FF3400'
                        "
                      >
                        {{ props.item.estado }}
                      </v-chip>
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
            <v-layout v-if="listado_funcionarios_acefalos.length > 0">
              <v-flex xs9>
                <h4>
                  <strong
                    >Listado de servidores publicos que no cuentan con jefe
                  </strong>
                </h4>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs3>
                <v-menu open-on-hover buttom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">help_outline</v-icon>
                  </template>
                  <v-card>
                    <v-card-text class="ayuda">
                      <v-layout>
                        <v-flex class="text-xs-center caption">
                          <strong>
                            <p><v-icon>help_outline</v-icon></p>
                            <p>La lista de los siguientes servidores seran</p>
                            <p>
                              aprobados directamente por su superior jerarquico
                            </p>
                            <p>ya que no cuentan con un jefe en este momento</p>
                            
                          </strong>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-menu>
              </v-flex>
            </v-layout>
            <v-layout v-if="listado_funcionarios_acefalos.length > 0">
              <v-flex xs12>
                <v-data-table
                  :items="listado_funcionarios_acefalos"
                  class="elevation-1"
                  hide-actions
                  :headers="headers"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">{{ props.item.nombre }}</td>
                    <td class="text-xs-center">{{ props.item.unidad }}</td>
                    <td class="text-xs-center">
                      <v-chip
                        dark
                        :color="
                          props.item.id_estado == 22
                            ? '#9637FF'
                            : props.item.id_estado == 51
                            ? '#00DB15'
                            : '#6f9eb8'
                        "
                      >
                        {{ props.item.estado }}
                      </v-chip>
                      </td>
                        <td class="text-xs-center">
                      <v-chip
                        dark
                        :color="props.item.bandera_acefalia == 1 && props.item.id_estado==51
                            ? '#9637FF': '#FF3400'"
                      >
                        Jefe acefálo
                      </v-chip>
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click.prevent="close()" :loading="loading"
            ><v-icon>close</v-icon>
            Cancelar
          </v-btn>

          <v-btn
            color="primary"
            @click.prevent="aprobarProgramacion()"
            :disabled="!this.bandera_aprobacion"
            ><v-icon>done</v-icon>
            Aprobar
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      listado_funcionarios: [],
      listado_funcionarios_acefalos: [],
      valid: false,
      loading: false,
      estado_vacacion: [],
      nombre: null,
      fecha_ingreso: null,
      user: this.$storage.get("user"),
      fecha_desde: "",
      fecha_hasta: "",
      persona: null,
      saldo: null,
      periodo: null,
      id: null,
      id_programacion: null,
      headers: [
        { text: "Nombre", sortable: false, align: "center" },
        { text: "Dependencia", sortable: false, align: "center" },
        { text: "Estado", sortable: false, align: "center" },
      ],
      bandera_aprobacion: true,
    };
  },
  mounted() {
    this.$bus.$on(
      "openDialogAprobarUnidadesProgramacionJefeJerarquico",
      async () => {
        await this.cargarListadoFuncionario();
        this.dialog = true;
      }
    );
  },
  methods: {
    async cargarListadoFuncionario() {
      let res = [];
      this.bandera_aprobacion= true
      let lista_funcionarios = [];
      this.listado_funcionarios = [];
      let lista_funcionarios_jefe_Acefalo = [];
      this.listado_funcionarios_acefalos = [];
      let user = this.$storage.get("user"); //user.nro_item
      try {
        console.log(`
							query{
							runQuery(consulta:"SELECT vacaciones.fn_verifica_estados_de_aprobacion_jerarquico(${user.id_persona},${this.$route.params.gestion},'${user.nro_item}')"){
								respuesta
							}
							}
						`);
        res = await this.$service.graphql({
          query: `
							query{
							runQuery(consulta:"SELECT vacaciones.fn_verifica_estados_de_aprobacion_jerarquico(${user.id_persona},${this.$route.params.gestion},'${user.nro_item}')"){
								respuesta
							}
							}
						`,
        });
        console.log(res.runQuery.respuesta[0]
            .fn_verifica_estados_de_aprobacion_jerarquico)
        res =
          res.runQuery.respuesta[0]
            .fn_verifica_estados_de_aprobacion_jerarquico;
        let res2 = res.split("|");
        let res3 = res.split(";");
        res3.splice(res3.length - 1);
        if (res2[0] == "0") {
          for (let i = 0; i < res3.length; i++) {
            const element = res3[i];
            let element3 = {};
            let elemento1 = element.split("|");

            if (elemento1[0] == "0") {
              element3.unidad = elemento1[1];
              element3.nombre = elemento1[2];
              element3.id_estado = elemento1[3];
              element3.estado = elemento1[4];
              element3.id_unidad = elemento1[5];
              element3.bandera_acefalia = elemento1[6];
            } else {
              element3.unidad = elemento1[0];
              element3.nombre = elemento1[1];
              element3.id_estado = elemento1[2];
              element3.estado = elemento1[3];
              element3.id_unidad = elemento1[4];
              element3.bandera_acefalia = elemento1[5];
            }
            //recorriendo la lista de servidores publicos
            if (
              (element3.id_estado != 51 && element3.bandera_acefalia == 0) ||
              (element3.id_estado == 51 &&
                element3.bandera_acefalia == 0 &&
                element3.id_unidad != user.unidad[0].id)||(element3.id_estado != 51 &&  element3.id_unidad == user.unidad[0].id)
            ) {
              lista_funcionarios.push(element3);
            }
            if ((element3.id_estado == 51 &&
              element3.bandera_acefalia == "1" &&
              element3.id_unidad != user.unidad[0].id) || (element3.id_estado == 66 &&
              element3.bandera_acefalia == "1" &&
              element3.id_unidad != user.unidad[0].id)) {
              lista_funcionarios_jefe_Acefalo.push(element3);
             
            }
          }
          if (lista_funcionarios.length>0) {
              this.bandera_aprobacion = false;
          }
          if (lista_funcionarios==[]) {
              this.bandera_aprobacion = true;
          }
        } else {
          lista_funcionarios = [];
          this.bandera_aprobacion = true
        }
        this.listado_funcionarios = lista_funcionarios;
        this.listado_funcionarios_acefalos = lista_funcionarios_jefe_Acefalo;
      } catch (error) {
        console.log(error);
      }
    },
    close() {
      this.listado_funcionarios = [];
      this.loading = false;
      this.valid = false;
      this.$bus.$emit("closeDialogAprobarUnidadesProgramacionJefeJerarquico");
      this.dialog = false;
    },

    async aprobarProgramacion() {
      this.$confirm(
        "¿Esta seguro de aprobar la programación de vacaciones?",
        async () => {
          let user = this.$storage.get("user");
          let respuesta;
          let resps = [];
          let correcto = true;
          this.loading = true;

          try {
       
            respuesta = await this.$service.graphql({
              query: `query{
              runQuery(consulta:"select vacaciones.fn_aprueba_vacacion_programada_por_jerarquico(${
                user.id_persona
              },${parseInt(this.$route.params.gestion)},${parseInt(user.id)})"){
                respuesta
              }
            }
          `,
            });
            respuesta =
              respuesta.runQuery.respuesta[0]
                .fn_aprueba_vacacion_programada_por_jerarquico;
            resps = respuesta.split("|");
            correcto = resps[0];
            if (correcto == "1") {
              this.$message.success(
                "Las programaciones de las unidades fuerón aprobadas exitosamente"
              );
            } else {
              this.$message.error(resps[1]);
            }
          } catch (error) {
            console.log(error);
          }
          this.loading = false;
          this.close();
        }
      );
    },
  },
};
</script>

<style>
.ayuda {
  background: #7ae4db8f;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/vacaciones/dialogs/AprobarUnidadesProgramacionJefeJerarquico.vue